<template>
  <div class="bg-white px-4 py-5 sm:p-6">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div class="text-xl font-bold" v-text="(view==='crear'?'Crear ':'Actualizar ')+entity.value.toLowerCase()"></div>
      <button @click="$emit('updateValues', {'view': 'listar'});"
              class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <slot></slot>
  </div>
  <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
    <button type="button" @click="saveUpdateData()"
            v-text="view==='crear'?'Guardar':'Actualizar'"
            class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
    </button>
  </div>
</template>

<script>

import {saveUpdateData} from "@/layouts/main/functions";

/**
 Componente para crear o actualizar entidades.
 @vue-prop {string} view - Vista actual del componente, puede ser 'crear' o 'actualizar'.
 @vue-prop {string} entity - Entidad actual.
 @vue-prop {Function} customUpdateLoadData - Función para personalizar la actualización de los datos cargados.
 @vue-prop {Array} customSaveData - Métodos personalizados para guardar los datos.
 @vue-prop {string} primaryKey - Clave primaria de la entidad.
 @vue-prop {boolean} skipDefaultSave - Indica si se debe omitir el guardado por defecto.
 @vue-event {Function} updateValues - Evento para actualizar valores.
 */
export default {
  name: 'CreateUpdateComponent',
  props: ['view', 'paginate', 'options', 'selectedData', 'loadData', 'entity', 'authToken', 'listApi', 'queries', 'customListData', 'customUpdateLoadData', 'customSaveData', 'primaryKey', 'skipDefaultSave'],
  emits: ["updateValues"],
  async setup(props,{ emit }) {
    if (props.customUpdateLoadData) props.customUpdateLoadData();
    return {
      saveUpdateData: async () => {
        if (props.customSaveData) await Promise.all(props.customSaveData.map(async (methodSaveData) => await methodSaveData()));
        if (!props.skipDefaultSave) await saveUpdateData(props, emit, false, false, false, props.primaryKey);
      }
    }
  }
}
</script>